module.exports = __webpack_public_path__ + "img/ai替代的职业@2x.52569aff.png";